// BenitoAvatar — la CARA de Benito, dibujada del Benito real: labrador
// amarillo ("labrador" entre comillas: quedó chiquitito) con su pelota
// calipso mordida, tal como en las fotos del fundador. Complementa a
// PresenciaBenito (la firma punto+trazo, que sigue siendo los ESTADOS del
// agente en header/FAB/pestaña): la presencia es el gesto, este es el rostro.
//
// Es ilustración de identidad, no señal clínica: paleta propia fija (misma
// categoría que el arte de la ficha de Play Store), estable en claro/oscuro
// y nítida a 24px, donde una foto comprimida se vuelve ruido. Si algún día
// se prefiere la foto real, este componente pasa a envolver un <img> y los
// callers no cambian.
export default function BenitoAvatar({ size = 24, className = "", ...resto }) {
  // Ignora props ajenas (mismo criterio que PresenciaBenito).
  void resto;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label="Benito"
      focusable="false"
      className={className}
    >
      {/* orejas caídas y largas (de labrador, no de peluche), detrás de la cabeza */}
      <ellipse cx="15" cy="30" rx="5.5" ry="14" fill="#D4B278" transform="rotate(10 15 30)" />
      <ellipse cx="49" cy="30" rx="5.5" ry="14" fill="#D4B278" transform="rotate(-10 49 30)" />
      {/* cabeza */}
      <ellipse cx="32" cy="28" rx="19" ry="17.5" fill="#E9D3A3" />
      {/* ojos (café oscuro, mirada de labrador) */}
      <circle cx="25.5" cy="25" r="2.4" fill="#3F3128" />
      <circle cx="38.5" cy="25" r="2.4" fill="#3F3128" />
      {/* hocico claro + nariz grande */}
      <ellipse cx="32" cy="35" rx="9.5" ry="7.5" fill="#F4E6C4" />
      <ellipse cx="32" cy="32" rx="4.2" ry="3.2" fill="#6B5140" />
      {/* la pelota calipso, mordida como en la foto (tapa el mentón) */}
      <circle cx="32" cy="52" r="11" fill="#7CCFC9" />
      <path d="M 22.5 48 Q 32 55.5 41.5 48" stroke="#FFFFFF" strokeWidth="1.7" fill="none" opacity="0.8" strokeLinecap="round" />
      <path d="M 22.5 56.5 Q 32 49.5 41.5 56.5" stroke="#FFFFFF" strokeWidth="1.7" fill="none" opacity="0.8" strokeLinecap="round" />
    </svg>
  );
}
